import { call, put } from "redux-saga/effects";
import { StorageUtil, toCamel, toSnake } from "utils";
import { getInteractor } from "services/local.service";
import { ApiConstant, KeyConstant, SystemConstant } from "const";
import { checkCurrentBranchByPrefix, formatArray2Key, formatPagingParams } from "./saga.helper";
import store, { AccountActions, ProfileActions, SystemActions } from "redux-store";
import { remoteApiFactory } from "services";
import { checkBlockedContact, createGroupService } from "pubsub/services/conversation.service";
import { getCommonLang } from "utils/lang.utils";

export function* getAccountList(action) {
  let errorReason;
  try {
    const { data } = action;
    const prefixKey = action?.prefixKey || StorageUtil.getCurrentPrefixKey();
    const apiPayload = formatPagingParams({ limit: 10, filter: JSON.stringify(data) });

    const response = yield call(remoteApiFactory.getBranchApi(prefixKey).getAccountList, apiPayload);
    const responseData = response?.data?.data;
    if (response.status === ApiConstant.STT_OK && Array.isArray(responseData)) {
      yield put(
        AccountActions.accountSuccess({
          accountList: toCamel(responseData) || [],
        }),
      );
    } else {
      errorReason = response;
    }
  } catch (error) {
    console.error(error);
    errorReason = error;
  }

  if (errorReason) yield put(AccountActions.accountFailure(errorReason));
}

export function* saveAccountListByIds(prefixKey, data) {
  const isCurrentBranch = checkCurrentBranchByPrefix(prefixKey);
  let errorReason;

  try {
    const param = toSnake(data);

    const response = yield call(remoteApiFactory.getBranchApi(prefixKey).getAccountByIds, formatArray2Key(param));
    const responseData = response.data;

    if (response.status === ApiConstant.STT_OK && Array.isArray(response.data)) {
      yield getInteractor(prefixKey).LocalAccountService.save(responseData);
      const currentAccountId = StorageUtil.getItem(KeyConstant.KEY_ACCOUNT_ID, prefixKey);
      const isUpdateCurrentAccount = responseData.find(item => item.id === currentAccountId);

      if (isCurrentBranch && isUpdateCurrentAccount) {
        yield put(
          ProfileActions.profileSet({
            updatedProfile: new Date().getTime(),
          }),
        );
      }
    } else {
      errorReason = response;
    }
  } catch (error) {
    console.error(error);
    errorReason = error;
  }

  if (isCurrentBranch && errorReason) yield put(AccountActions.accountFailure(errorReason));
}

export const blockUser = async action => {
  let errorReason;
  try {
    const { groupId, blockedAccountId } = action.data;
    const prefixKey = action?.prefixKey || StorageUtil.getCurrentPrefixKey();

    const groupDetail = await getInteractor(prefixKey).LocalGroupService.get(groupId);
    if (groupDetail.groupType === SystemConstant.GROUP_CHAT_TYPE.personal && groupDetail.draftGroupMembers) {
      const groupMembers = groupDetail.draftGroupMembers;
      const createGroupData = {
        encryptionF: SystemConstant.ENCRYPTION_TYPE.NORMAL_ENCRYPTION,
        groupId: groupId,
        name: groupDetail.name,
        groupType: SystemConstant.GROUP_CHAT_TYPE.personal,
        members: groupMembers,
        privateF: 0,
      };

      const remoteGroup = await createGroupService(prefixKey, createGroupData);
      if (false === Boolean(remoteGroup && remoteGroup.id)) {
        store.dispatch(
          SystemActions.systemSet({
            toast: {
              content: getCommonLang("TXT_SERVER_ERROR"),
              severity: "error",
              modified: Date.now(),
            },
          }),
        );
        return;
      }
    }

    const response = await remoteApiFactory.getBranchApi(prefixKey).blockAccount({
      blocked_account_id: blockedAccountId,
    });
    if (response.status === ApiConstant.STT_OK) {
      await getInteractor(prefixKey).LocalContactService.blockContact(blockedAccountId);

      store.dispatch(
        AccountActions.accountSuccess({
          blockAccountId: blockedAccountId,
        }),
      );

      const currentAccountId = StorageUtil.getItem(KeyConstant.KEY_ACCOUNT_ID);
      await checkBlockedContact(prefixKey, groupId, [blockedAccountId, currentAccountId], blockedAccountId);
    } else {
      errorReason = response;
    }
  } catch (error) {
    console.error(error);
    errorReason = error;
  }

  if (errorReason) store.dispatch(AccountActions.accountFailure(errorReason));
};

export const unblockUser = async action => {
  let errorReason;
  try {
    const { groupId, blockedAccountId } = action.data;
    const prefixKey = action?.prefixKey || StorageUtil.getCurrentPrefixKey();

    const response = await remoteApiFactory.getBranchApi(prefixKey).unblockAccount({
      blocked_account_id: blockedAccountId,
    });
    if (response.status === ApiConstant.STT_OK) {
      await getInteractor(prefixKey).LocalContactService.unblockContact(blockedAccountId);

      store.dispatch(
        AccountActions.accountSuccess({
          blockAccountId: blockedAccountId,
        }),
      );

      const currentAccountId = StorageUtil.getItem(KeyConstant.KEY_ACCOUNT_ID);
      await checkBlockedContact(prefixKey, groupId, [blockedAccountId, currentAccountId], blockedAccountId);
    } else {
      errorReason = response;
    }
  } catch (error) {
    console.error(error);
    errorReason = error;
  }

  if (errorReason) store.dispatch(AccountActions.accountFailure(errorReason));
};
